<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BUSINESS MANAGEMENT & COMMERCE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">University Profile</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool02/4%20(1).jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">The Arni School of Business Management & Commerce</h2>
                <p>The ARNI School of Business Management & Commerce is the place where potential leaders transform into
                    business professionals. Students looking to pursue their career in the field of business and finance
                    management opt for ‘The School of Business Management & Commerce degree courses from ARNI University
                    division. Our approach to encouraging future leaders, entrepreneurs, and professionals is not only
                    to shape the business world but to also contribute to economic, social, and environmental progress.
                    Our programs are designed to equip students with the necessary skills and knowledge in this
                    fast-paced business world.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision </b> - Through our continued efforts and dedication to craft the leaders for the business
                    world,
                    our vision is to be recognized leading educational institute for business and finance education that
                    inspires students to think creatively, act ethically, and lead responsibly.
                </p>
                <p><b>Mission </b> – Our mission is to provide a transformation education that blends academic rigor
                    with practical experience, ensuring that our students are well-prepared to face the challenges of
                    the business world with our dynamic programs, experienced faculty, and industry partnership.
                </p>
                <h2>Postgraduate and Undergraduate Business and Management Courses</h2>
                <p>Our business and management courses are tailored to meet the needs of undergraduate, graduate, and
                    professional students. Through internships, networking events, and experiential learning projects,
                    students gain real-world experience and prepare for a successful career. We emphasize leadership,
                    critical thinking, and a global vision, training students in effective communication and
                    problem-solving methods. Our commitment is to make India a better place by creating knowledge and
                    cultivating entrepreneurial skills.
                </p>
                <p><b>Scope </b> - Students pursuing commerce or business management courses have diverse opportunities
                    in
                    accounting, finance, marketing, human resources, banking, entrepreneurship, and consulting, with
                    roles in corporate, government, non-profit, and entrepreneurial ventures.
                </p>
                <ul>
                    <li> Networking is important to stay updated in the business world, we provide students with
                        international exposure and internships.
                    </li>
                    <li>The business management courses degree holders will get high-level jobs in numerous fields such
                        as banks, agencies, and non-profit organizations or run their own ventures.
                    </li>
                    <li>We believe in developing well-rounded individuals who are not only academically competent but
                        also socially responsible and personally fulfilled.
                    </li>
                </ul>
                <p>
                    <b>Join us in this exciting journey, and together, let's build a brighter, more sustainable future
                        for
                        the business world.</b>
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 align-items-center">
    <div class="container">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">18</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">32</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon d-flex justify-content-center">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">5</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">BusinessStudies</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">BBA</td>
                            </tr>
                            <tr>
                                <td class="time">MBA</td>
                            </tr>
                            <tr>
                                <td class="time">Ph.D Management</td>
                            </tr>
                            <tr>
                                <td class="time">BBA (Specialization)</td>
                            </tr>
                            <tr>
                                <td class="time">MBA (Retail Management)</td>
                            </tr>
                            <tr>
                                <td class="time">Risk Reduction and Management</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Direct Selling</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma on Disaster Risk Reduction and Management</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Event Management</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Digital Marketing</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Commerce</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">B.Com</td>
                            </tr>
                            <tr>
                                <td class="time">M.com</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Hospitality Management</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">MBA (Hospital Management)</td>
                            </tr>
                            <tr>
                                <td class="time">MBA (Pharmaceutical Management)</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
